import {
  createActions, asyncInitialState, asyncSelectors, dateComparator
} from '../../utils'

export const { types, actions } = createActions({
  setSelected: (row) => ({ row }),
  setWarehouse: (defaultWarehouse) => ({ defaultWarehouse }),
  reset: () => null,
  asyncs: {
  }
}, 'IESLostSales');

const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    doubleClickActionTab: '',
    suppressEditDeleteInContextMenu: true,
    rowModelType: 'serverSide',
  },
  Columns: [
    { headerName: 'Date', field: 'TransactionDate', comparator: dateComparator, minWidth: 150 },
    { headerName: 'Lost sale', field: 'LostSale', type: 'numericColumn' },
    { headerName: 'Type', field: 'LostTypeDescription' },
    { headerName: 'Quantity', field: 'QuantityDisplay', type: 'numericColumn' },
    { headerName: 'Balance', field: 'BalanceDisplay', type: 'numericColumn' },
    { headerName: 'Reference', field: 'Reference' },
    { headerName: 'Sales entity', field: 'SalesEntity' },
    { headerName: 'Financial period', field: 'FinancialPeriod', comparator: dateComparator },
    { headerName: 'Cost each', field: 'CostEachDisplay', type: 'numericColumn' },
    { headerName: 'Sell price', field: 'PriceDisplay', type: 'numericColumn' },
    {
      headerName: 'Customer',
      field: 'CustomerIdDisplay',
      minWidth: 150,
      suppressSorting: true,
      hyperlinkParamGetter: (row) => {
        if (row.data && row.data.CustomerId) {
          return {
            CustomerId: row.data.CustomerId,
            CustomerAccountNumber: row.data.CustomerIdDisplay,
            FieldValue: row.data.CustomerIdDisplay
          };
        } else return null;
      },
      cellRenderer: 'hyperLinkRenderer',
      cellRendererParams: {
        link: '/customer-enquiry'
      }
    },
    { headerName: 'Customer name', field: 'CustomerIdLabel' },
    { headerName: 'Customer P/O', field: 'CustomerPO' },
    { headerName: 'User ID', field: 'UserIdValue' },
    { headerName: 'User name', field: 'UserName' },
  ],
  Data: [],
  selectedFilters: {
    Warehouse: 'QW',
    SalesEntity: '',
    LostType: ''
  },
  filterRow: {
    formName: 'IESLostSalesFilters',
    hidePreFilters: false,
    parameters: [
      {
        id: 0,
        type: 'EX_LOOKUP_FIELD',
        props: {
          label: 'Warehouse',
          name: 'Warehouse',
          lookupName: 'WarehouseEntity',
          size: 'small',
          required: true
        }
      },
      {
        id: 1,
        type: 'EX_LOOKUP_FIELD',
        props: {
          label: 'Sales entity',
          name: 'SalesEntity',
          lookupName: 'SalesEntity',
          size: 'small',
          required: false
        }
      },
      {
        id: 2,
        type: 'AUTOCOMPLETE_FIELD',
        props: {
          label: 'Lost type',
          name: 'LostType',
          required: false,
          apiPrefs: {
            path: '/CustomTypes/Lookup/Losttype/Search',
            method: 'POST',
            params: {
              SearchText: ''
            }
          },
        }
      },
    ]
  }
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.reset:
      return initialState;
    case types.setSelected:
      const selected = action.data.row;
      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }
    case types.setWarehouse:
      const warehouse = action.data.defaultWarehouse;
      return {
        ...state,
        data: {
          ...state.data,
          selectedFilters: {
            ...state.data.selectedFilters,
            Warehouse: warehouse
          }
        }
      };

    default:
      return state
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.inventoryEnquiry.sales.lostSales,
  {
    data: data => data.Data,
    selected: data => data.selected,
  }
)

const syncSelector = {
  isLoading: state => state.inventoryEnquiry.sales.lostSales.fetch_loading,
  gridOptions: state => state.inventoryEnquiry.sales.lostSales.data.gridOptions,
  columns: state => state.inventoryEnquiry.sales.lostSales.data.Columns,
  filterRow: state => state.inventoryEnquiry.sales.lostSales.data.filterRow,
  selectedFilters: state => state.inventoryEnquiry.sales.lostSales.data.selectedFilters,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)